import React from 'react'

import { Formik, Form } from 'formik'
import { useQueryClient } from '@tanstack/react-query'

import { Stack, Typography, DialogTitle, DialogContent, DialogActions } from '@mui/material'
import { AddCard } from '@mui/icons-material'

import { useAuth } from '@/hooks/useAuth'
import {
  CardFormFields,
  cardFormInitialValues,
  cardFormValidationSchema,
  useCardAddFormSubmit,
} from '@/components/CardAddForm'

import { ChargingStepProps, StartChargingStep } from '../hooks/useStartCharging/types'
import { ChargingStepActions } from '../components/ChargingStepActions'

export const AddCardStep: React.FC<ChargingStepProps> = ({ startChargingMethods }) => {
  const { goToStep } = startChargingMethods
  const queryClient = useQueryClient()
  const { user } = useAuth()

  const goToPaymentMethodStep = () => {
    goToStep(StartChargingStep.PAYMENT_METHOD)
  }

  const handleSuccess = () => {
    queryClient.invalidateQueries({ queryKey: ['payment-credit-cards'] })
    goToPaymentMethodStep()
  }

  const handleSubmit = useCardAddFormSubmit(handleSuccess)

  return (
    <Formik initialValues={cardFormInitialValues} validationSchema={cardFormValidationSchema} onSubmit={handleSubmit}>
      {({ submitForm, isSubmitting }) => (
        <>
          <DialogTitle>
            <Stack direction="row" alignItems="center" spacing={1}>
              <AddCard color="primary" />
              <Typography variant="h6" fontWeight="bold">
                Adicionar cartão
              </Typography>
            </Stack>
          </DialogTitle>

          <DialogContent>
            <Stack spacing={3} sx={{ paddingTop: 1 }}>
              <Form>
                <CardFormFields />
              </Form>
            </Stack>
          </DialogContent>

          <DialogActions>
            <ChargingStepActions sx={{ width: '100%' }}>
              <ChargingStepActions.ForwardButton
                onClick={submitForm}
                loading={isSubmitting}
                disabled={isSubmitting || !user?.phone}
              >
                Adicionar cartão
              </ChargingStepActions.ForwardButton>
              <ChargingStepActions.BackwardButton onClick={goToPaymentMethodStep} />
            </ChargingStepActions>
          </DialogActions>
        </>
      )}
    </Formik>
  )
}
